import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { MsalGuard, MsalInterceptor, MsalService } from '@azure/msal-angular';

var url = window.location.href;
var countryId = window.location.href.split('/')[5];
var engagementId = window.location.href.split('/')[4];

  if(url.includes('viewengagement') && (countryId != undefined || engagementId != undefined)){
    localStorage.setItem('WBCountryId',countryId);
    localStorage.setItem('WBEngagementId',engagementId);
  }
/* This condition is for performance testing to modify bearer token */
if (!environment.isMsalEnabled) {
 // MsalGuard.prototype.canActivate = () => true;
  
  MsalInterceptor.prototype.intercept = (req, next) => {
    const access = localStorage.getItem('dbamsaltoken');
    req = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + environment.sampleToken
      }
    });
    return next.handle(req);
  };

  // MsalService.prototype.instance.acti = (): any => {
  //   if (!localStorage.getItem('dbamsaltoken')) return true;
  //   return {
  //     idToken: {
  //       scope: [],
  //       // other claims if required
  //     }
  //   };
  // };
}




if (environment.production) {  
  enableProdMode();
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => { });
